import styled from 'styled-components';
import { h6Styles } from 'utils/resuable-css';

export const DraggableContainer = styled.div`
  margin: 10px 0;
  margin-right: 10px;
  width: 100%;
  background-color: white;
  border-radius: 10px;
  box-shadow: lightgray 0px 0px 24px 5px;
  border: 2px solid lightgray;
  overflow: auto;
  resize: vertical !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (max-width: 960px) {
    width: 100%;
  }
`;

export const TopBar = styled.div`
  padding: 12px 5px 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #d8d8d8;
  i {
    font-size: 18px;
    cursor: pointer;
  }
  @media only screen and (max-width: 1600px) {
    height: 5.3em;
  }
  @media only screen and (max-width: 960px) {
    height: auto;
  }
  @media only screen and (max-width: 792px) {
    height: 5.3em;
  }
  @media only screen and (max-width: 655px) {
    height: auto;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  h5 {
    margin: 3px 12px 0 5px;
  }
  .count {
    color: red;
    margin: 0;
    margin-right: 8px;
    font-weight: bold;
    border: 1px solid red;
    border-radius: 50%;
    padding: 3px 9px;
  }
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  padding: 12px 18px;
  @media only screen and (max-width: 1440px) {
    padding: 12px;
  }
`;

export const NotificationContainer = styled.div`
  padding: 0 8px 0 3px;
  margin: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f2f2f2;
  border-radius: 3px;
  i {
    cursor: pointer;
  }
`;

export const Alert = styled.div`
  padding: 12px 14px;
  h6 {
    margin: 0;
  }
  p {
    margin: 0;
    margin-top: 3px;
  }
`;

export const TradeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0.7em 2em;
  p {
    margin: 0;
    cursor: pointer;
    text-decoration: underline;
    font-weight: bold;
    color: #666666;
  }
  .space {
    margin: 0 8px;
  }
`;

export const ModalContainer = styled.div`
  width: 40em;
  padding: 10px 20px;
`;

export const SelectDateTime = styled.div`
  margin-top: 0.5em;
  h5 {
    margin: 0;
    margin-bottom: 10px;
  }
  .react-datepicker {
    border: 2px solid #d8d8d8;
  }
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    background: ${(props) => props.theme.primaryDarkColor};
  }

  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected {
    background: ${(props) => props.theme.primaryDarkColor};
  }
`;

export const TextArea = styled.div`
  margin: 1em 0;
  textarea {
    font-size: 17px;
    width: 100%;
    border: 2px solid lightgray;
    border-bottom: 2px solid ${(props) => props.theme.primaryDarkColor};
    border-radius: 5px;
    resize: none;
    padding: 10px;
  }
`;

export const DateTime = styled.div`
  display: flex;
  margin-top: 0.5em;
  h6 {
    margin: 0;
    margin-top: 3px;
    font-weight: bold;
  }
`;

export const AccountSC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 1px);
`;

export const PopupContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
`;

export const Values = styled.h6`
  display: flex;
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};
  margin: 0;
  padding: 1em;
  font-weight: bold;
  cursor: pointer;
`;

export const Divider = styled.div`
  display: block;
  height: 1px;
  background: ${(props) => props.theme.dividerColor};
`;
